import { useFeatureValue } from '@growthbook/growthbook-react'

export const useSubscriptionCostInfo = () => {
  const priceConfig = useFeatureValue<CostInfoConfig>('whc-subscription-cost-info', null)

  return {
    overline: priceConfig?.modalOverline ?? '',
    title: priceConfig?.modalTitle ?? '',
    subtitle: priceConfig?.modalSubtitle ?? '',
    subscribeCTALink: priceConfig?.modalSubscribeCTALink ?? '',
    CTACaptionText: priceConfig?.CTACaptionText ?? '',
  }
}

export type CostInfoConfig = Record<string, string> | null
